import React, { Component } from "react";
import { DropdownButton, MenuItem, ButtonToolbar } from 'react-bootstrap';
import Calendar from 'react-calendar';
import { genURL, gengetURLTEST } from './../_getjson';
import axios from 'axios'
require('./../_css/PopUpOther.css');
export default class PSDoc extends Component {
    state = {
        MenuItem: "",
    }
    GetDropdownApi = (list) => {
        this.setState({
            MenuItem: <DropdownButton title={<i className="far fa-caret-square-down selectFix"></i>}/* title="Organization" */ /* pullCenter */ bsSize="xsmall" id="dropdown-size-extra-small"
                // pullRight title={<i className="far fa-caret-square-down selectFix"></i>} 
                noCaret bsStyle="default"> {list.map(function (object, oi) { return list[oi]; })}</DropdownButton>
        });
    }
    CalendarOnChange = (data, type) => {
        if (data !== "") {
            var Backup = "";
            var today = new Date(data);
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            if (dd < 10) { dd = '0' + dd }
            if (mm < 10) { mm = '0' + mm }

            today = dd + '/' + mm + '/' + (yyyy + 543);
            this.onClickMenu(today);
            setTimeout(() => {
                Backup = this.state.MenuItem;
                this.setState({ MenuItem: "" });
            }, 0);
            setTimeout(() => {
                this.setState({ MenuItem: Backup });
            }, 10);
        } else {
            today = "";
        }

        return today;
    }

    componentDidMount() {
        var list = [];
        let url
        switch (this.props.type) {

            case "Maingroup":
                this.props.SelectSetData(this.props.type, "");
                url = "CSARMAINGROUP/GetAll?MFLAG=1";
                // var data_ = this.state.MenuItem;
              //  console.log(genURL(url));
                axios.get(genURL(url), { timeout: 3600 }).then(res => {
                    // console.log(res['sta']);
                    if (res.data === undefined) {
                        return
                    }
                    for (var i = 0; i < res.data.length; i++) {
                        list[i] = <MenuItem key={i} onClick={this.onClickMenu.bind(null, res.data[i].CODE + "|" + res.data[i].MYNAMETH)}>{res.data[i].MYNAMETH}</MenuItem>;

                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });

                break;
            case "Subgroup1":
                this.props.SelectSetData(this.props.type, "");
                url = "CSARSUBGROUP1/GetAll?MFLAG=1";
                // var data_ = this.state.MenuItem;
            //    console.log(genURL(url));
                axios.get(genURL(url), { timeout: 3600 }).then(res => {
                    if (res.data === undefined) {
                        return
                    }
                    for (var i = 0; i < res.data.length; i++) {
                        list[i] = <MenuItem key={i} onClick={this.onClickMenu.bind(null, res.data[i].CODE + "|" + res.data[i].MYNAMETH)}>{res.data[i].MYNAMETH}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });
                break;
            case "Closeflag":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ใช้งาน")}> ใช้งาน </MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ไม่ใช้งาน")}> ไม่ใช้งาน </MenuItem>
                        </DropdownButton>
                }); break;
            /************p2***********/
            case "Pricelevel":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ระดับที่ 1")} readOnly>ระดับที่ 1</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ระดับที่ 2")} readOnly>ระดับที่ 2</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2|ระดับที่ 3")} readOnly>ระดับที่ 3</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "3|ระดับที่ 4")} readOnly>ระดับที่ 4</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "4|ระดับที่ 5")} readOnly>ระดับที่ 5</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "5|ระดับที่ 6")} readOnly>ระดับที่ 6</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "6|ระดับที่ 7")} readOnly>ระดับที่ 7</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "7|ระดับที่ 8")} readOnly>ระดับที่ 8</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "8|ระดับที่ 9")} readOnly>ระดับที่ 9</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "9|ระดับที่ 10")} readOnly>ระดับที่ 10</MenuItem>

                        </DropdownButton>
                }); break;
            case "Taxtype":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ราคาไม่รวมภาษี")}>ราคาไม่รวมภาษี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ราคารวมภาษี")}>ราคารวมภาษี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2|ภาษีอัตราศูนย์")}>ภาษีอัตราศูนย์</MenuItem>
                        </DropdownButton>
                }); break;
            case "Currencycode":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "TH|บาท")}>บาท</MenuItem>
                        </DropdownButton>
                }); break;

            /************p3***********/
            case "Persontype":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|นิติบุคคล")}>นิติบุคคล</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|บุคคลธรรมดา")}>บุคคลธรรมดา</MenuItem>
                        </DropdownButton>
                }); break;
            case "Creditflag":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ปิดบัญชี")}>ปิดบัญชี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|เปิดบัญชี")}>เปิดบัญชี</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "2|หยุดชั่วคราว")}>หยุดชั่วคราว</MenuItem>
                        </DropdownButton>
                }); break;
            case "Sex":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ชาย")}>ชาย</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|หญิง")}>หญิง</MenuItem>
                        </DropdownButton>
                }); break;
            case "Occupation":
               // this.props.SelectSetData(this.props.type, ""); 
                let url_m = "psoccuoation/getall?top=300";
                var list = [];
                axios.get(genURL(url_m)).then(res => {
                    for (let index = 0; index < res.data.length; index++) {
                        list[index] = <MenuItem key={index} onClick={this.onClickMenu.bind(null, res.data[index].CODE + "|" + res.data[index].MYNAMETH)}>{"(" + res.data[index].CODE + ")-" + res.data[index].MYNAMETH}</MenuItem>;
                        if (list.length === res.data.length) {
                            this.GetDropdownApi(list);
                        }
                    }
                }); break;
 
            case "Prefix":
                this.props.SelectSetData(this.props.type, "");
                url = "PSPREFIX/ALL?MFLAG=1";
              //  console.log(genURL(url));
                axios.get(genURL(url), { timeout: 3600 }).then(res => {
                    var durationBody = res.data.map((item, i) => {
                        return (
                            <MenuItem key={i} onClick={this.onClickMenu.bind(null, item.CODE + "|" + item.MYNAMETH)}>{item.MYNAMETH}</MenuItem>
                        );
                    });
                    this.setState({
                        MenuItem:
                            <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                                {durationBody}
                                {/* <MenuItem onClick={this.onClickMenu.bind(null, code+"|"+text)}>{text}</MenuItem> */}
                                {/* <MenuItem onClick={this.onClickMenu.bind(null, "1|นาง")}>นาง</MenuItem>
                                <MenuItem onClick={this.onClickMenu.bind(null, "2|นางสาว")}>นางสาว</MenuItem> */}
                            </DropdownButton>
                    });
                }).catch(error => {
                    console.log(error);
                });
                break;
            case "Creditcode":
                this.props.SelectSetData(this.props.type, "");
                /*var url = "https://psmdapi.pspl.co.th/CSCREDITCODE/GetAll?api_key="+DataConfig.API_KEY[company]+"&jwt="+token;
                //console.log(url);
                var list = [];
                axios.get(url).then(
                    res =>{
                        for(var i =0 ; i<res.data.length;i++){
                            list[i] = <MenuItem onClick={this.onClickMenu.bind(null,res.data[i].CODE+"|"+res.data[i].MYNAMETH)}>{res.data[i].MYNAMETH}</MenuItem>;
                            if(list.length===res.data.length){
                                this.GetDropdownApi(list);
                            }
                        }                    
                    }
                );*/
                url = "CSCREDITCODE/GetCreditcode?MFLAG=1";
                // var data_ = this.state.MenuItem;
               // console.log(genURL(url));
                axios.get(genURL(url), { timeout: 3600 }).then(res => {
                    try {
                        for (var i = 0; i < res.data.length; i++) {
                            list[i] = <MenuItem key={i} onClick={this.onClickMenu.bind(null, res.data[i].CODE + "|" + res.data[i].MYNAMETH)}>{res.data[i].MYNAMETH}</MenuItem>;
                            if (list.length === res.data.length) {
                                this.GetDropdownApi(list);
                            }
                        }
                    } catch (error) {
                        // ...
                    }
                }).catch(error => {
                    console.log(error);
                });

                break;
            case "Creditshare":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "0|ใช้วงเงินส่วนตัว")}>ใช้วงเงินส่วนตัว</MenuItem>
                            <MenuItem onClick={this.onClickMenu.bind(null, "1|ใช้วงเงินรวม")}>ใช้วงเงินรวม</MenuItem>
                        </DropdownButton>
                }); break;
            case "Accountcode":
                this.props.SelectSetData(this.props.type, "");
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight title={<i className="far fa-caret-square-down selectFix"></i>} noCaret bsStyle="default">
                            <MenuItem onClick={this.onClickMenu.bind(null, "DB")}>DB</MenuItem>
                        </DropdownButton>
                }); break;

            case "Calendar": case "Calendar1": case "Calendar2": case "Calendar3":
                this.CalendarOnChange(new Date());
                //this.CalendarOnChange(""); 
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" id="dropdown-size-extra-small" pullRight noCaret title={<i className="far fa-caret-square-down selectFix"></i>} bsStyle="default">
                            <Calendar onChange={this.CalendarOnChange} value={this.state.date} className={"menu1"} />
                        </DropdownButton>
                }); break;
            case "Calendar-up": case "Calendar1-up": case "Calendar2-up": case "Calendar3-up":
                this.CalendarOnChange(new Date());
                this.setState({
                    MenuItem:
                        <DropdownButton bsSize="xsmall" dropup id="split-button-dropup" pullRight noCaret title={<i className="far fa-caret-square-down selectFix"></i>} bsStyle="default">
                            <Calendar onChange={this.CalendarOnChange} value={this.state.date} className={"menu1"} />
                        </DropdownButton>
                }); break;
            default: break;
        }
    }

    onClickMenu = (data) => {
        this.props.SelectSetData(this.props.type, data);
    }

    render() {
        return (
            <ButtonToolbar>
                {this.state.MenuItem}
            </ButtonToolbar>
        )
    }
}
